"use strict";

const ClinicalPort = {
  add: function (app) {
    // Track if core-ready has been dispatched
    if (typeof window.__coreReadyDispatched === "undefined") {
      window.__coreReadyDispatched = false;
    }

    if (app.ports.dispatchLoadClinicalPort) {
      app.ports.dispatchLoadClinicalPort.subscribe(async () => {
        // Prevent dispatching core-ready multiple times
        if (window.__coreReadyDispatched) return;

        window.__coreReadyDispatched = true;

        try {
          // Load EMR assets and wait for completion
          if (
            window.loadEMRAssets &&
            typeof window.loadEMRAssets === "function"
          ) {
            await window.loadEMRAssets();
          }

          window.dispatchEvent(new CustomEvent("core-ready"));
        } catch (error) {
          // Reset flag on error to allow retry
          window.__coreReadyDispatched = false;
          throw error;
        }
      });
    }

    if (app.ports.dispatchUnmountClinicalPort) {
      app.ports.dispatchUnmountClinicalPort.subscribe(() => {
        if (typeof window.unmountEmbeddedClinical === "function") {
          window.unmountEmbeddedClinical();
        }

        // Reset the core-ready flag so clinical can be mounted again
        window.__coreReadyDispatched = false;
      });
    }
  },
};

module.exports = ClinicalPort;
